/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
// Generated by build-products.mjs – DO NOT EDIT BY HAND.
//
// Kept separate from products.tsx on purpose: this map's dynamic imports reach every
// product scene, and products.tsx is imported app-wide via scenes/urls.ts. In one module,
// jest's --findRelatedTests would mark ~the whole test suite as related to any scene change.
// Import this only from scene-mounting code (scenes/appScenes.ts).

/** This const is auto-generated, as is the whole file */
export const productScenes: Record<string, () => Promise<any>> = {
  Actions: () => import("../../products/actions/frontend/pages/Actions"),
  Action: () => import("../../products/actions/frontend/pages/Action"),
  NewAction: () => import("../../products/actions/frontend/pages/Action"),
  AIGateway: () => import("../../products/ai_gateway/frontend/AIGatewayScene"),
  AIObservability: () => import("../../products/ai_observability/frontend/AIObservabilityScene"),
  AIObservabilityTrace: () =>
    import("../../products/ai_observability/frontend/AIObservabilityTraceScene"),
  AIObservabilitySession: () =>
    import("../../products/ai_observability/frontend/AIObservabilitySessionScene"),
  AIObservabilityUsers: () =>
    import("../../products/ai_observability/frontend/AIObservabilityUsers"),
  AIObservabilityPlayground: () =>
    import("../../products/ai_observability/frontend/playground/AIObservabilityPlaygroundScene"),
  AIObservabilityDatasets: () =>
    import("../../products/ai_observability/frontend/datasets/AIObservabilityDatasetsScene"),
  AIObservabilityDataset: () =>
    import("../../products/ai_observability/frontend/datasets/AIObservabilityDatasetScene"),
  AIObservabilityEvaluations: () =>
    import("../../products/ai_observability/frontend/evaluations/AIObservabilityEvaluationsScene"),
  AIObservabilityEvaluation: () =>
    import("../../products/ai_observability/frontend/evaluations/AIObservabilityEvaluation"),
  AIObservabilityEvaluationTemplates: () =>
    import("../../products/ai_observability/frontend/evaluations/EvaluationTemplates"),
  AIObservabilityTags: () =>
    import("../../products/ai_observability/frontend/tags/AIObservabilityTagsScene"),
  AIObservabilityTag: () =>
    import("../../products/ai_observability/frontend/tags/AIObservabilityTag"),
  AIObservabilityPrompts: () =>
    import("../../products/ai_observability/frontend/prompts/LLMPromptsScene"),
  AIObservabilityPrompt: () =>
    import("../../products/ai_observability/frontend/prompts/LLMPromptScene"),
  AIObservabilityClusters: () =>
    import("../../products/ai_observability/frontend/clusters/AIObservabilityClustersScene"),
  AIObservabilityCluster: () =>
    import("../../products/ai_observability/frontend/clusters/AIObservabilityClusterScene"),
  Alerts: () => import("../../products/alerts/frontend/AlertsScene"),
  BusinessKnowledge: () =>
    import("../../products/business_knowledge/frontend/scenes/BusinessKnowledgeScene"),
  Transformations: () => import("../../frontend/src/scenes/data-pipelines/TransformationsScene"),
  EventFiltering: () =>
    import("../../frontend/src/scenes/data-pipelines/event-filtering/EventFilterScene"),
  CohortsStaffTools: () => import("../../products/cohorts/frontend/staff/CohortsStaffToolsScene"),
  SupportTickets: () =>
    import("../../products/conversations/frontend/scenes/tickets/SupportTicketsScene"),
  SupportTicketDetail: () =>
    import("../../products/conversations/frontend/scenes/ticket/SupportTicketScene"),
  SupportSettings: () =>
    import("../../products/conversations/frontend/scenes/settings/SupportSettingsScene"),
  CustomerAnalytics: () =>
    import("../../products/customer_analytics/frontend/CustomerAnalyticsScene"),
  CustomerAnalyticsConfiguration: () =>
    import("../../products/customer_analytics/frontend/scenes/CustomerAnalyticsConfigurationScene/CustomerAnalyticsConfigurationScene"),
  CustomerJourneyBuilder: () =>
    import("../../products/customer_analytics/frontend/scenes/CustomerJourneyBuilderScene/CustomerJourneyBuilderScene"),
  CustomerJourneyTemplates: () =>
    import("../../products/customer_analytics/frontend/scenes/CustomerJourneyTemplatesScene/CustomerJourneyTemplatesScene"),
  DataOps: () => import("../../products/data_warehouse/DataWarehouseScene"),
  Models: () => import("../../frontend/src/scenes/models/ModelsScene"),
  NodeDetail: () => import("../../frontend/src/scenes/models/NodeDetailScene"),
  Sources: () => import("../../products/data_warehouse/frontend/scenes/SourcesScene/SourcesScene"),
  DataWarehouseSource: () =>
    import("../../products/data_warehouse/frontend/scenes/SourceScene/SourceScene"),
  DataWarehouseSourceNew: () =>
    import("../../products/data_warehouse/frontend/scenes/NewSourceScene/NewSourceScene"),
  DataWarehouseSourceConnect: () =>
    import("../../products/data_warehouse/frontend/scenes/SourceConnectScene/SourceConnectScene"),
  DataWarehouseSourceSchema: () =>
    import("../../products/data_warehouse/frontend/scenes/SchemaScene/SchemaScene"),
  EarlyAccessFeatures: () =>
    import("../../products/early_access_features/frontend/EarlyAccessFeatures"),
  EarlyAccessFeature: () =>
    import("../../products/early_access_features/frontend/EarlyAccessFeature"),
  EndpointsScene: () => import("../../products/endpoints/frontend/EndpointsScene"),
  EndpointScene: () => import("../../products/endpoints/frontend/EndpointScene"),
  EngineeringAnalytics: () =>
    import("../../products/engineering_analytics/frontend/scenes/EngineeringAnalyticsScene"),
  EngineeringAnalyticsPullRequest: () =>
    import("../../products/engineering_analytics/frontend/scenes/PullRequestDetailScene"),
  EngineeringAnalyticsWorkflowRun: () =>
    import("../../products/engineering_analytics/frontend/scenes/WorkflowRunDetailScene"),
  EngineeringAnalyticsWorkflowRuns: () =>
    import("../../products/engineering_analytics/frontend/scenes/WorkflowRunsScene"),
  EngineeringAnalyticsAuthor: () =>
    import("../../products/engineering_analytics/frontend/scenes/EngineeringAnalyticsAuthorScene"),
  EngineeringAnalyticsTeam: () =>
    import("../../products/engineering_analytics/frontend/scenes/EngineeringAnalyticsTeamScene"),
  ErrorTracking: () =>
    import("../../products/error_tracking/frontend/scenes/ErrorTrackingScene/ErrorTrackingScene"),
  ErrorTrackingIssue: () =>
    import("../../products/error_tracking/frontend/scenes/ErrorTrackingIssueScene/ErrorTrackingIssueScene"),
  ErrorTrackingIssueFingerprints: () =>
    import("../../products/error_tracking/frontend/scenes/ErrorTrackingFingerprintsScene/ErrorTrackingIssueFingerprintsScene"),
  ErrorTrackingFingerprint: () =>
    import("../../products/error_tracking/frontend/scenes/ErrorTrackingFingerprintScene/ErrorTrackingFingerprintScene"),
  FeatureFlagTemplates: () =>
    import("../../products/feature_flags/frontend/FeatureFlagTemplatesScene"),
  FeatureFlagsStaffTools: () =>
    import("../../products/feature_flags/frontend/staff/FeatureFlagsStaffToolsScene"),
  Game368Hedgehogs: () => import("../../products/games/368Hedgehogs/368Hedgehogs"),
  FlappyHog: () => import("../../products/games/FlappyHog/FlappyHog"),
  IdentityMatching: () => import("../../products/growth/frontend/IdentityMatchingScene"),
  LegalDocuments: () =>
    import("../../products/legal_documents/frontend/scenes/LegalDocumentsScene"),
  LegalDocumentNew: () =>
    import("../../products/legal_documents/frontend/scenes/LegalDocumentNewScene"),
  Links: () => import("../../products/links/frontend/LinksScene"),
  Link: () => import("../../products/links/frontend/LinkScene"),
  LiveDebugger: () => import("../../products/live_debugger/frontend/LiveDebugger"),
  Logs: () => import("../../products/logs/frontend/LogsScene"),
  LogsAlertDetail: () =>
    import("../../products/logs/frontend/scenes/LogsAlertDetailScene/LogsAlertDetailScene"),
  LogsAlertNotificationDetail: () =>
    import("../../products/logs/frontend/scenes/LogsAlertNotificationDetailScene/LogsAlertNotificationDetailScene"),
  LogsSamplingNew: () =>
    import("../../products/logs/frontend/scenes/LogsSamplingNewScene/LogsSamplingNewScene"),
  LogsSamplingDetail: () =>
    import("../../products/logs/frontend/scenes/LogsSamplingDetailScene/LogsSamplingDetailScene"),
  ManagedMigration: () => import("../../products/managed_migrations/frontend/ManagedMigration"),
  ManagedMigrationNew: () => import("../../products/managed_migrations/frontend/ManagedMigration"),
  MCPAnalytics: () => import("../../products/mcp_analytics/frontend/MCPAnalyticsScene"),
  MCPAnalyticsToolDetail: () =>
    import("../../products/mcp_analytics/frontend/MCPAnalyticsToolDetail"),
  Metrics: () => import("../../products/metrics/frontend/MetricsScene"),
  TaskTracker: () => import("../../products/posthog_ai/frontend/scenes/TaskTracker/TaskTracker"),
  Pulse: () => import("../../products/pulse/frontend/PulseScene"),
  ReplayVision: () =>
    import("../../products/replay_vision/frontend/replay_scanners/ReplayScannersScene"),
  ReplayVisionScanner: () =>
    import("../../products/replay_vision/frontend/replay_scanners/ReplayScanner"),
  ReplayVisionScannerEditor: () =>
    import("../../products/replay_vision/frontend/replay_scanners/ScannerEditorScene"),
  ReplayVisionObservation: () =>
    import("../../products/replay_vision/frontend/observations/ReplayObservation"),
  ReplayVisionAction: () =>
    import("../../products/replay_vision/frontend/replay_scanners/VisionActionScene"),
  ReplayVisionActionEditor: () =>
    import("../../products/replay_vision/frontend/replay_scanners/ActionEditorScene"),
  ReplayVisionActionRun: () =>
    import("../../products/replay_vision/frontend/replay_scanners/VisionActionRunScene"),
  CodeReview: () => import("../../products/review_hog/frontend/CodeReviewScene"),
  SessionGroupSummariesTable: () =>
    import("../../products/session_summaries/frontend/SessionGroupSummariesTable"),
  SessionGroupSummary: () =>
    import("../../products/session_summaries/frontend/SessionGroupSummaryScene"),
  Skills: () => import("../../products/skills/frontend/LLMSkillsScene"),
  Skill: () => import("../../products/skills/frontend/LLMSkillScene"),
  Stamphog: () => import("../../products/stamphog/frontend/scenes/StamphogScene/StamphogScene"),
  Subscriptions: () => import("../../products/subscriptions/frontend/scenes/SubscriptionsScene"),
  Subscription: () => import("../../products/subscriptions/frontend/scenes/SubscriptionScene"),
  SlackTaskContext: () => import("../../products/tasks/frontend/SlackTaskContextScene"),
  Tracing: () => import("../../products/tracing/frontend/TracingScene"),
  TracingOperation: () => import("../../products/tracing/frontend/TracingOperationScene"),
  UserInterviews: () => import("../../products/user_interviews/frontend/UserInterviews"),
  UserInterview: () => import("../../products/user_interviews/frontend/UserInterview"),
  UserInterviewResponse: () =>
    import("../../products/user_interviews/frontend/UserInterviewResponse"),
  VisualReviewIndex: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewIndexScene"),
  VisualReviewRuns: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewRunsScene"),
  VisualReviewRun: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewRunScene"),
  VisualReviewSettings: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewSettingsScene"),
  VisualReviewSnapshotHistory: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewSnapshotHistoryScene"),
  VisualReviewSnapshotOverview: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewSnapshotOverviewScene"),
  Workflows: () => import("../../products/workflows/frontend/WorkflowsScene"),
  Workflow: () => import("../../products/workflows/frontend/Workflows/WorkflowScene"),
  WorkflowsLibraryTemplate: () =>
    import("../../products/workflows/frontend/TemplateLibrary/MessageTemplate"),
};
